// extracted by mini-css-extract-plugin
export default {"home":"FinalExam_home__a27Fq","home2":"FinalExam_home2__fS+II","hr":"FinalExam_hr__+iO59","main":"FinalExam_main__SySth"};